export default __webpack_public_path__ + "static/media/1Enviro Waste Services.c050ea70.png";